import { render, staticRenderFns } from "./DocumentPortalUpload.vue?vue&type=template&id=6726f914&scoped=true&"
import script from "./DocumentPortalUpload.vue?vue&type=script&lang=js&"
export * from "./DocumentPortalUpload.vue?vue&type=script&lang=js&"
import style0 from "./DocumentPortalUpload.vue?vue&type=style&index=0&id=6726f914&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6726f914",
  null
  
)

export default component.exports